import React, { useState } from 'react';

interface ExpandableTextProps {
  text: string;
  limit?: number;
  className?: string;
  buttonClassName?: string;
}

const ExpandableText: React.FC<ExpandableTextProps> = ({
  text,
  limit = 150,
  className = 'text-sm text-gray-900 mt-1',
  buttonClassName = 'ml-1 text-blue-600 hover:text-blue-800 text-xs font-medium focus:outline-none',
}) => {
  const [expanded, setExpanded] = useState(false);

  if (!text || text.length <= limit) {
    return <p className={className}>{text}</p>;
  }

  return (
    <div className={className}>
      <span>
        {expanded ? text : `${text.slice(0, limit)}...`}
      </span>
      <button
        onClick={() => setExpanded((prev) => !prev)}
        className={buttonClassName}
      >
        {expanded ? 'See Less' : 'See More'}
      </button>
    </div>
  );
};

export default ExpandableText;
